// extracted by mini-css-extract-plugin
export default {"body":"SummaryCanvas_body__U95Au"};